import { ReactElement, useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiInput,
  RfUiModal,
  RfUiMultiselect,
} from 'renfe-components';

import jsPDF from 'jspdf';

import { createStructuredSelector } from 'reselect';
import {
  makeSelectAlumnoPracticaParse2,
  makeSelectCursosPracticaParse2,
  makeSelectFormadoresCursos,
  makeSelectPracticasList,
} from 'store/practicas/selectors';
import {
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
  makeSelectPerfilesUsuarioNombreUsuario,
  makesSelectFiltrosParse,
} from 'store/usuarios/selectors';
import {
  getFilterAlumnoPracticaRequest,
  getFilterCursoPracticaRequest,
  getFormadorCursoRequest,
} from 'store/practicas/actions';
import { setStatePracticeSelected } from 'store/app/actions';
import { getDefaultPracticeState } from 'utils/practiceUtils';
import { arrayToAPI } from 'utils/listUtils';
import { language } from '../../utils/literals';
import { isMobileOnly } from 'react-device-detect';
import './filterCertificadosPracticas.scss';
import {
  makeSelectCursos,
} from 'store/cursos/selectors';
import {useCan} from 'hooks/visibilidadComponentes';

import vialogRegularFontUrl from '../../fonts/vialog-lt-regular.ttf';
import allianceBoldFontUrl from '../../fonts/vialog-lt-regular.ttf';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  nombreUsuario: makeSelectPerfilesUsuarioNombreUsuario(),
  cursos: makeSelectCursosPracticaParse2(),
  formadores: makeSelectFormadoresCursos(),
  alumnos: makeSelectAlumnoPracticaParse2(),
  filtros: makesSelectFiltrosParse(),
  alumnosFiltro: makeSelectAlumnoPracticaParse2(),
  practicas: makeSelectPracticasList(),
  cursos2: makeSelectCursos(),
} as any);


//funciones auxiliares
function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function abToBase64(ab: ArrayBuffer): string {
  let binary = "";
  const bytes = new Uint8Array(ab);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function base64ToBlobUrl(b64: string, mime = "application/pdf") {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);
  }
  return URL.createObjectURL(new Blob([bytes], { type: mime }));
}

const FilterListPractice = ({ handleSubmit, initValues }): ReactElement => {
  const dispatch = useDispatch();
  const {
    profileActive,
    idUsuario,
    nombreUsuario,
      cursos,
    formadores,
    alumnos,
    filtros,
    alumnosFiltro,
    practicas,
    cursos2,
  } = useSelector<any, any>(selectors);

  //opción seleccionar todos




  //modal para la comprobacion de cursos seleccionados
  const [modalCerradoType, setModalCerradoType] = useState('');

  const openModalCerrado = () => {
    setModalCerradoType('alert');
  };
  const closeModalCerrado = () => {
    setModalCerradoType('');
  };




  //Modal para la selección de formadores
  //1-modal si el curso seleccionado no tiene formadores asociados
  const [mensajeSinFormadores, setMensajeSinFormadores] = useState('');
  const [modalCerradoFormadoresSinFormadoresType, setModalCerradoFormadoresSinFormadoresType] = useState('');

  const closeModalCerradoFormadoresSinFormadores = () => {
    setModalCerradoFormadoresSinFormadoresType('');
  };
  //2-modal si se ha seleccionado un curso con un solo formador asociado
  const [mensajeUnFormador, setMensajeUnFormador] = useState('');
  const [modalCerradoFormadoresUnFormadorType, setModalCerradoFormadoresUnFormadorType] = useState('');

  const closeModalCerradoFormadoresUnFormador = () => {
    setModalCerradoFormadoresUnFormadorType('');
  };


  //3-modal si no se han seleccionado al menos 2 formadores por curso
  const [modalCerradoFormadoresType, setModalCerradoFormadoresType] = useState('');
  const [mensajeFormadores, setMensajeFormadores] = useState('');

  const closeModalCerradoFormadores = () => {
    setModalCerradoFormadoresType('');
  };

  const [savedFilterListPractice]: [any, any] = useState(initValues);

  const defaultEmptyFilter = {
    alumnos: '',
    ascDesc: '',
    cursos: '-1',
    elemFin: 2147483647,
    elemInicio: 0,
    estados: 'VA,RE,PV',
    fechaFin: 99999999999999,
    fechaInicio: 0,
    instructores: '',
    orden: '',
    sociedades: '',
    savedValues: false,
    lastProfile: profileActive?.ID_PERFIL,
  };

  const [selectedCursos, setSelectedCursos]: [any, any] = useState('');

  const saveFilters = (filters) => {
    filters.estados = 'VA,RE,PV';
    filters.fechaFin = 99999999999999;
    filters.fechaInicio = 0;
  };

  const getFechaDesdeListAlumn = (): number => {
    return 0;
  };

  const [selectedAlumnos, setSelectedAlumnos]: [any, any] = useState('');
  const [selectedFormadores, setSelectedFormadores] = useState<string[]>([]);
  const [multiselectResetKey, setMultiselectResetKey] = useState(0);
  const [multiselectResetFormadorKey, setMultiselectResetFormadorKey] = useState(0);

  const newInit = {
    ...savedFilterListPractice,
    fechaInicio: getFechaDesdeListAlumn(),
  };
  const [iniFilter, setInitFilter] = useState(newInit);

  useEffect(() => {
    setInitFilter(newInit);
    filter.current = { ...newInit };
    dispatch(getFilterCursoPracticaRequest({}));
  }, [savedFilterListPractice]);

  const filter: any = useRef(iniFilter);

  useEffect(() => {
    let courseArray = [{}];
    if (iniFilter.cursos !== '') {
      iniFilter.cursos.split(',').forEach((filterCurso) => {
        const newCourses = JSON.parse(cursos).filter((c) => {
          return c.value.toString() === filterCurso;
        });
        courseArray.push({
          label: newCourses[0].label.toString(),
          value: newCourses[0].value.toString(),
        });
      });
    }
    setSelectedCursos(JSON.stringify(courseArray));

    let alumnArray = [{}];
    if (iniFilter.alumnos !== '') {
      iniFilter.alumnos.split(',').forEach((filterAlumno) => {
        const newAlumns = JSON.parse(alumnos).filter((a) => {
          return a.value.toString() === filterAlumno;
        });
        alumnArray.push({
          label: newAlumns[0].label.toString(),
          value: newAlumns[0].value.toString(),
        });
      });
    }
    setSelectedAlumnos(JSON.stringify(alumnArray));

    let filtroArray = [{}];
    if (iniFilter?.filtros) {
      iniFilter.filtros.forEach((filtro: any) => {
        const newFiltros = JSON.parse(filtros).filter((f) => {
          return f.value.toString() === filtro;
        });
        filtroArray.push({
          label: newFiltros[0].label.toString(),
          value: newFiltros[0].value.toString(),
        });
      });
    }
    setSelectedFiltros(JSON.stringify(filtroArray));

  }, []);

  const parseDefaultStatesToString = (data: any) => {
    let res = '';
    data = JSON.parse(data);
    data.forEach((item: any) => {
      res = res === '' ? item.value : res + ',' + item.value;
    });
    return res;
  };

  let defaultPracticeState = useMemo(
    () => getDefaultPracticeState(profileActive, savedFilterListPractice),
    [profileActive, savedFilterListPractice]
  );

  useEffect(() => {
    dispatch(
      setStatePracticeSelected(parseDefaultStatesToString(defaultPracticeState))
    );
  }, [defaultPracticeState]);

  type Option = { label: string; value: any };
const normalizeFormadoresToOptions = (raw: any): Option[] => {
  try {
    if (typeof raw === 'string') raw = JSON.parse(raw);
  } catch {
    return [];
  }

  if (!Array.isArray(raw)) return [];

  const seenIds = new Set<string>();
  const result: Option[] = [];

  for (const f of raw) {
    const id = f?.ID_FORMADOR;
    const nombre = f?.NOMBRE_FORMADOR;
    if (!id || !nombre) continue;

    const idStr = String(id);

    // Evitar duplicados
    if (seenIds.has(idStr)) continue;

    seenIds.add(idStr);
    result.push({ label: `${idStr} - ${nombre}`, value: idStr });
  }

  return result;
};

    const [formadoresFiltrados, setFormadoresFiltrados] = useState<any>();


    const handleSelectedCourse = (e: any) => {
      const detail = Array.isArray(e?.detail) ? e.detail : [];

      // dejar solo la última selección
      const last = detail.length ? detail[detail.length - 1] : null;
      const singleArr = last ? [last] : [];

      // refrescar el multiselect para que visualmente quede una sola opción marcada
      setSelectedCursos(JSON.stringify(singleArr));

      const cursos = arrayToAPI(singleArr);

      if (cursos === '') {
        setIsFilterActive(false);
        cleanFilters();
        return;
      }

      filter.current = { ...filter.current, cursos };

      setSelectedAlumnos('[]');

      dispatch(
        getFilterAlumnoPracticaRequest({
          cursos,
          sociedades: filter.current.sociedades,
        })
      );

      setIsFilterActive(true);

      const formadoresCurso = formadores.filter(
        (f) => String(f.ID_CURSO) === String(cursos)
      );
      setSelectedFormadores([]);
      setFormadoresFiltrados(normalizeFormadoresToOptions(formadoresCurso));
    };


//alumnos

  useEffect(() => {
      //para que aparezca seleccionar todos
      setMultiselectResetKey(k => k + 1);
  }, [alumnos]);

  const handleStudentSelected = (e: any) => {
    const alumnos = arrayToAPI(e.detail);
    filter.current = { ...filter.current, alumnos };
  };
  const cleanFilters = () => {
    setSelectedOptionFilter(false);
    setIsFilterActive(false);

    // reset UI states (usa el mismo tipo que usas en mount: '[]' para los multiselectes que esperan string JSON)
    setSelectedCursos('[]');
    setSelectedAlumnos('[]');
    setSelectedFiltros('[]');
    setSelectedFormadores([]); // formadores lo tienes como array de ids

    // si quieres que las opciones de formadores desaparezcan al limpiar:
    setFormadoresFiltrados([]);

    // reset del filtro interno
    filter.current = { ...iniFilter, formadores: '' };


    // forzar remount de los multiselects (para que vuelvan a leer defaultChecksRemake)
    setMultiselectResetKey(k => k + 1);
    setMultiselectResetFormadorKey(k => k + 1);
    filter.current = { ...defaultEmptyFilter };
    handleSubmit(filter.current);

};

const handleSelectedFormador = (e: any) => {
  const seleccionados = arrayToAPI(e.detail);

  const nuevosIds = seleccionados
    ? seleccionados.split(',').map((id: string) => id.trim())
    : [];

  filter.current = {
    ...filter.current,
    formadores: nuevosIds.join(','),
  };


  setSelectedFormadores(nuevosIds);
};



type ValidacionFormadores = {
  sinFormadores: string[];
  unFormador: { curso: string; formador: any }[];
  insuficientes: string[];
};

const getCursosSeleccionadosFiltro = (): string[] => {
  return filter.current.cursos.split(',').map(s => s.trim()).filter(Boolean);
};

const contarFormadoresSeleccionados = (formadoresDeCurso: any[]): number => {
  return formadoresDeCurso.filter((f) =>
    selectedFormadores.includes(String(f.ID_FORMADOR))
  ).length;
};

const validarFormadoresCurso = (
  curso: string,
  validacion: ValidacionFormadores
) => {
  const formadoresDeCurso = formadores.filter((f) => String(f.ID_CURSO) === String(curso));

  if (formadoresDeCurso.length === 0) {
    validacion.sinFormadores.push(curso);
    return;
  }

  const formadoresCountSeleccionados = contarFormadoresSeleccionados(formadoresDeCurso);

  if (formadoresDeCurso.length === 1) {
    if (formadoresCountSeleccionados === 0) {
      validacion.unFormador.push({ curso, formador: formadoresDeCurso[0] });
    }
    return;
  }

  if (formadoresCountSeleccionados < 2) {
    validacion.insuficientes.push(curso);
  }
};

const validarFormadoresSeleccionados = (cursosSeleccionados: string[]): ValidacionFormadores => {
  const validacion: ValidacionFormadores = {
    sinFormadores: [],
    unFormador: [],
    insuficientes: [],
  };

  cursosSeleccionados.forEach((curso) => validarFormadoresCurso(curso, validacion));
  return validacion;
};

const abrirModalSinFormadores = (sinFormadores: string[]) => {
  const lista = sinFormadores.join(', ');
  setMensajeSinFormadores(
    `Los siguientes cursos no tienen formadores asociados: ${lista}. Por favor, seleccione otro curso o contacte con el administrador.`
  );
  setModalCerradoFormadoresSinFormadoresType('alert');
};

const abrirModalUnFormador = (unFormador: { curso: string; formador: any }[]) => {
  const partes = unFormador.map(u => {
    const idF = u.formador?.ID_FORMADOR ?? 'N/A';
    const nombre = u.formador?.NOMBRE_FORMADOR ?? 'N/D';
    return `Curso ${u.curso}: ID_FORMADOR = ${idF} - ${nombre}`;
  });

  setMensajeUnFormador(
    `Los siguientes cursos tienen un único formador y no está seleccionado:\n${partes.join('\n')}`
  );
  setModalCerradoFormadoresUnFormadorType('alert');
};

const abrirModalInsuficientes = (insuficientes: string[]) => {
  const lista = insuficientes.join(', ');
  setMensajeFormadores(
    `Por favor, seleccione al menos 2 formadores para los siguientes cursos: ${lista}`
  );
  setModalCerradoFormadoresType('alert');
};

const mostrarValidacionFormadores = (validacion: ValidacionFormadores): boolean => {
  if (validacion.sinFormadores.length > 0) {
    abrirModalSinFormadores(validacion.sinFormadores);
    return true;
  }

  if (validacion.unFormador.length > 0) {
    abrirModalUnFormador(validacion.unFormador);
    return true;
  }

  if (validacion.insuficientes.length > 0) {
    abrirModalInsuficientes(validacion.insuficientes);
    return true;
  }

  return false;
};

const handlerSubmitFilters = async () => {
  // comprobamos que si hay cursos seleccionados, tengan al menos 2 formadores seleccionados cada uno
  // si no hay cursos seleccionados no se puede filtrar, se muestra el modal de aviso
  if (filter.current.cursos === '' || filter.current.cursos === '-1') {
    openModalCerrado();
    return;
  }

  const cursosSeleccionados = getCursosSeleccionadosFiltro();
  const validacion = validarFormadoresSeleccionados(cursosSeleccionados);

  if (mostrarValidacionFormadores(validacion)) {
    return;
  }

  // ejecutar submit: no hay advertencias que mostrar
  filter.current = { ...filter.current, savedValues: true };
  saveFilters(filter.current);
  handleSubmit(filter.current);
  setSelectedAlumnos(filter.current.alumnos);
};

  //Filtro opciones
  const [, setSelectedFiltros]: [any, any] = useState('');
  const [, setSelectedOptionFilter] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const optionsFilter = '';


  const [cursosFiltrados, setCursosFiltrados] = useState<any>();




  //blur
  const multiselectFormadoresRef = useRef<any>(null);
  const multiselectCursosRef = useRef<any>(null);

const getPointerPath = (ev: PointerEvent): EventTarget[] => {
  return ev.composedPath?.() || [];
};

const isMultiselectElement = (n: EventTarget): boolean => {
  try {
    const el = n as Element;
    return !!(
      el?.classList &&
      (el.classList.contains('rf-ui-multiselect') ||
        el.classList.contains('awesomplete') ||
        el.classList.contains('rf-ui-multiselect__container-all') ||
        el.classList.contains('rf-ui-multiselect__close') ||
        (el.tagName === 'INPUT' && el.closest?.('.rf-ui-multiselect')))
    );
  } catch {
    return false;
  }
};

const isCheckAllElement = (n: EventTarget): boolean => {
  try {
    const el = n as Element;
    return !!el?.classList?.contains('rf-ui-multiselect__container-all');
  } catch {
    return false;
  }
};

const resetIgnoreNextBlur = (ignoreNextBlurRef: { current: boolean }) => {
  ignoreNextBlurRef.current = true;
  setTimeout(() => {
    ignoreNextBlurRef.current = false;
  }, 0);
};

useEffect(() => {
  const host = multiselectFormadoresRef.current;
  if (!host) return;

  const ignoreNextBlurRef = { current: false } as { current: boolean };

  // Handler para el evento checkEvent (seleccionar todos)
  const onHostCheckEvent = (ev: Event) => {
    const ce = ev as CustomEvent;
    const checked = !!ce.detail;
    if (checked) {
      const ids = (formadoresFiltrados ?? []).map((f: any) => String(f.value));
      setSelectedFormadores(ids);
      filter.current = { ...filter.current, formadores: ids.join(',') };
    } else {
      setSelectedFormadores([]);
      filter.current = { ...filter.current, formadores: '' };
    }
  };
  host.addEventListener('checkEvent', onHostCheckEvent as EventListener);

  // pointerdown capture: detecta intentos de click antes de que otros handlers actúen
  const onPointerDown = (ev: PointerEvent) => {
    const path = getPointerPath(ev);

    if (path.length === 0) {
      return;
    }

    if (path.some(isMultiselectElement)) {
      if (path.some(isCheckAllElement)) {
        // evitamos remount
        resetIgnoreNextBlur(ignoreNextBlurRef);
      }
      return;
    }

    // Sólo forzamos remount si no venimos de un "Seleccionar todos" controlado por el flag.
    if (!ignoreNextBlurRef.current) {
      setMultiselectResetFormadorKey((k) => k + 1);
    }
    ignoreNextBlurRef.current = false;
  };

  document.addEventListener('pointerdown', onPointerDown, true);

  return () => {
    host.removeEventListener('checkEvent', onHostCheckEvent as EventListener);
    document.removeEventListener('pointerdown', onPointerDown, true);
  };
}, [formadoresFiltrados, multiselectFormadoresRef]);

  useEffect(() => {
    // Si las opciones de formadores ya están cargadas, forzamos el remount
    if (Array.isArray(formadoresFiltrados) && formadoresFiltrados.length > 0) {
      // incrementa la key para forzar que RfUiMultiselect se remonte y ejecute componentDidLoad()
      setMultiselectResetFormadorKey(k => k + 1);
    }
  }, [formadoresFiltrados]);

  const [estadosExcluidos] = useState(["CE", "FI"]);
  const [tipoPracticaConduccionEfectiva] = useState(["CT", "AC", "MA"]);

  useEffect(() => {
      const filtrados = JSON.parse(cursos).filter(curso => estadosExcluidos.includes(curso.state) && curso.label?.toLowerCase().includes("licencia de maquinista"));
      setCursosFiltrados(filtrados);
      let idCursosFiltrados = filtrados.map((id) => id.value);

     dispatch(getFormadorCursoRequest(idCursosFiltrados));
     cleanFilters();

  }, [profileActive, cursos]);



  type AlumnoExtraido = {
  nif: string;
  nombreCompleto: string;
  nombre: string;
  apellidos: string;
  };


const extraerInfoAlumnos = (alumnos: { label: string; value: string }[]): AlumnoExtraido[] => {
  return alumnos.map(({ label }) => {
    const [nif, datosPersona] = label.split(" - ");
    const [apellidos, nombres] = datosPersona.split(",").map(s => s.trim());

    // Unimos nombre + apellidos en orden natural
    const nombreCompleto = `${nombres} ${apellidos}`;

    return {
      nif: nif.trim(),
      nombreCompleto: nombreCompleto.trim(),
      nombre: nombres,
      apellidos: apellidos
    };
  });
};


const extraerHorasTotalesPracticas = (listEstPracticasAlumno: any[]) => {
  let horasTotalesMin = 0;

  for (const p of listEstPracticasAlumno) {
    if (p.MIN_PRACTICA) {
      horasTotalesMin += p.MIN_PRACTICA;

    }
  }

  const formatoHHmm = (horasTotalesMin / 60).toLocaleString('es-ES', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  return formatoHHmm;
};


const [enableGenerarCertificado, setEnableGenerarCertificado] = useState(false);

  useEffect(() => {
    const listPracticasConduccionEfectiva = practicas.filter((el) => tipoPracticaConduccionEfectiva.includes(el.ID_TIPO_PRACTICA));

    if(listPracticasConduccionEfectiva.length > 0) {
      setEnableGenerarCertificado(true);
    }else {
      setEnableGenerarCertificado(false);
    }
  }, [practicas]);



const parseAlumnosFiltro = (): { label: string; value: string; active?: string }[] => {
  try {
    return typeof alumnosFiltro === 'string' ? JSON.parse(alumnosFiltro) : alumnosFiltro;
  } catch (error) {
    return [];
  }
};

const getCursosSeleccionadosCertificado = () => {
  return cursosFiltrados.filter((e) => filter.current.cursos.includes(e.value));
};

const getListaFormadoresCurso = (cursoId: string): string[] => {
  return formadores
    .filter((e) => cursoId === e.ID_CURSO && selectedFormadores.includes(String(e.ID_FORMADOR)))
    .map(({ NOMBRE_FORMADOR }) => NOMBRE_FORMADOR);
};

const getAlumnosCertificado = (
  parsedAlumnos: { label: string; value: string; active?: string }[]
): AlumnoExtraido[] => {
  const alumnosCertificado = filter.current.alumnos === ''
    ? parsedAlumnos
    : parsedAlumnos.filter((alumno) => filter.current.alumnos.includes(alumno.value));

  return extraerInfoAlumnos(alumnosCertificado);
};

const getPracticasConduccionEfectiva = (alumno: AlumnoExtraido, cursoId: string) => {
  return practicas.filter(
    (el) =>
      alumno.nif === el.ID_ALUMNO &&
      cursoId === el.ID_CURSO &&
      tipoPracticaConduccionEfectiva.includes(el.ID_TIPO_PRACTICA)
  );
};


const generarPDFAlumnoCurso = async (
  alumno: AlumnoExtraido,
  cur: any,
  listaFormadores: string[]
) => {
  const listEstPracticasAlumno = getPracticasConduccionEfectiva(alumno, cur.value);

  if (listEstPracticasAlumno.length === 0) {
    return;
  }

  const horasTotales = extraerHorasTotalesPracticas(listEstPracticasAlumno);

  if (horasTotales === "0,00") {
    return;
  }

  const provincia = cursos2.filter((e) => e.ID_CURSO === cur.value).map(e => e.PROVINCIA_CURSO);
  const DELAY_MS = 250;

  await generarPDFCertificado({
    nombre: alumno.nombreCompleto,
    nif: alumno.nif,
    sede: provincia,
    horas: horasTotales,
    curso: cur.label,
    formadores: listaFormadores,
    nombreAlumno: alumno.nombre,
    apellidosAlumno: alumno.apellidos
  });
  await delay(DELAY_MS);
};

const generarPDFCurso = async (cur: any, alumnosExtraidos: AlumnoExtraido[]) => {
  const listaFormadores = getListaFormadoresCurso(cur.value);

  for (const alumno of alumnosExtraidos) {
    await generarPDFAlumnoCurso(alumno, cur, listaFormadores);
  }
};

const generarPDF = async () => {
  //obtenemos los alumnos
  const parsedAlumnos = parseAlumnosFiltro();
  //obtenemos los cursos seleccionados
  const cursosSeleccionados = getCursosSeleccionadosCertificado();
  const alumnosExtraidos = getAlumnosCertificado(parsedAlumnos);

  for (const cur of cursosSeleccionados) {
    await generarPDFCurso(cur, alumnosExtraidos);
  }
};

  interface CertificadoData {
    nombre: string;
    nif: string;
    sede: string;
    horas: string; // en formato "HH,mm"
    curso: string; //curso a certificar
    formadores: string[];
    nombreAlumno: string;
    apellidosAlumno: string;
  }
  // Utilidad para formatear la fecha en español
  const formatearFechaActual = (): string => {
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const hoy = new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const año = hoy.getFullYear();

    return `${dia} de ${mes} de ${año}`;
  };

  const formatearListado = (nombres: string[]): string => {
  if (nombres.length === 0) return "";
  if (nombres.length === 1) return nombres[0];
  if (nombres.length === 2) return `${nombres[0]} y ${nombres[1]}`;
  return `${nombres.slice(0, -1).join(", ")} y ${nombres[nombres.length - 1]}`;
};

// Asegura que cada nombre empieza por "D. "
const conTratamiento = (nombres: string[]): string[] =>
  nombres.map(n => (/^(D\.|Dª\.)/i.test(n.trim()) ? n.trim() : `D. ${n.trim()}`));





const renfeLogoBase64 ="data:image/png;base64,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";
const canSee = useCan();
//FIRMA CERTIFICADOS
type PdfCertificadoContext = {
  doc: any;
  marginLeft: number;
  topMarginNext: number;
  bottomMargin: number;
  pageWidth: number;
  pageHeight: number;
  maxTextWidth: number;
  centerX: number;
  y: number;
};

const addPageReset = (ctx: PdfCertificadoContext) => {
  ctx.doc.addPage();
  ctx.y = ctx.topMarginNext;
};

const ensureSpace = (ctx: PdfCertificadoContext, lineH = 6) => {
  if (ctx.y + lineH > ctx.pageHeight - ctx.bottomMargin) {
    addPageReset(ctx);
  }
};

const writeLines = (ctx: PdfCertificadoContext, lines: string[], lineH = 6) => {
  lines.forEach(line => {
    ensureSpace(ctx, lineH);
    ctx.doc.text(line, ctx.marginLeft, ctx.y);
    ctx.y += lineH;
  });
};

const writeHeader = (ctx: PdfCertificadoContext) => {
  const logoX = 15, logoY = 30, logoWidth = 40, logoHeight = 15;
  ctx.doc.setFontSize(8.5);
  setCertificateFont(ctx.doc);
  ctx.doc.setTextColor(150);

  const headerLines = [
    "Dirección de Formación",
    "Escuela Técnica Profesional de",
    "Conducción y Operaciones",
  ];
  const headerBlockStartY = 20, headerLineHeight = 5, headerBlockWidth = 60;
  const headerBlockX = ctx.centerX - headerBlockWidth / 2 + 8;
  headerLines.forEach((line, i) => {
    const yy = headerBlockStartY + i * headerLineHeight;
    ctx.doc.text(line, headerBlockX, yy);
  });
  ctx.doc.addImage(renfeLogoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);

  return logoY;
};

const writeTitle = (ctx: PdfCertificadoContext, logoY: number) => {
  ctx.y = logoY + 35;
  setCertificateFont(ctx.doc, "bold");
  ctx.doc.setFontSize(14);
  ctx.doc.setTextColor(0);
  ctx.doc.text("CERTIFICADO INDIVIDUAL DE FINALIZACIÓN DE LAS", ctx.centerX, ctx.y, { align: "center" });
  ctx.y += 8;
  ctx.doc.text("PRÁCTICAS DE CONDUCCIÓN EFECTIVA", ctx.centerX, ctx.y, { align: "center" });

  ctx.y += 5;
  ctx.doc.setDrawColor(90);
  ctx.doc.setLineWidth(1);
  ctx.doc.line(ctx.marginLeft, ctx.y, ctx.pageWidth - ctx.marginLeft, ctx.y);
};

const writeFormadoresHeader = (ctx: PdfCertificadoContext, formadoresConTrato: string[]) => {
  ctx.y += 12;
  setCertificateFont(ctx.doc);
  ctx.doc.setFontSize(12);

  const encabezadoFormadores = formatearListado(formadoresConTrato);

  if (!encabezadoFormadores) {
    ensureSpace(ctx, 6);
    ctx.doc.text("D. Formador,", ctx.marginLeft, ctx.y);
    ctx.y += 6;
    return;
  }

  const encabezadoLines = ctx.doc.splitTextToSize(`${encabezadoFormadores},`, ctx.maxTextWidth);
  writeLines(ctx, encabezadoLines, 6);
};

const writeCertificanBlock = (ctx: PdfCertificadoContext) => {
  ctx.y += 4;
  const bloqueCertifican = `Formadores de la Escuela Técnica Profesional de Conducción y Operaciones,
centro homologado de formación de RENFE Operadora,

CERTIFICAN:`;
  const certificanLines = ctx.doc.splitTextToSize(bloqueCertifican, ctx.maxTextWidth);
  writeLines(ctx, certificanLines, 6);
};

const writeBoldPhraseLine = (
  ctx: PdfCertificadoContext,
  line: string,
  boldPhrase: string
) => {
  const parts = line.split(boldPhrase);
  let x = ctx.marginLeft;

  setCertificateFont(ctx.doc);
  ctx.doc.text(parts[0], x, ctx.y);
  x += ctx.doc.getTextWidth(parts[0]);

  setCertificateFont(ctx.doc, "bold");
  ctx.doc.text(boldPhrase, x, ctx.y);
  x += ctx.doc.getTextWidth(boldPhrase);

  setCertificateFont(ctx.doc);
  ctx.doc.text(parts.slice(1).join(boldPhrase), x, ctx.y);
};

const writeJustifiedLine = (ctx: PdfCertificadoContext, line: string) => {
  const words = line.trim().split(/\s+/);

  if (words.length <= 1) {
    ctx.doc.text(line, ctx.marginLeft, ctx.y);
    return;
  }

  const totalWidth = words.reduce((acc, w) => acc + ctx.doc.getTextWidth(w), 0);
  const spaceWidth = (ctx.maxTextWidth - totalWidth) / (words.length - 1);
  let x = ctx.marginLeft;

  words.forEach((word, idx) => {
    ctx.doc.text(word, x, ctx.y);
    if (idx < words.length - 1) {
      x += ctx.doc.getTextWidth(word) + spaceWidth;
    }
  });
};

const writeParagraphLine = (
  ctx: PdfCertificadoContext,
  line: string,
  isLastLine: boolean,
  boldPhrase: string
) => {
  ensureSpace(ctx, 6);

  if (line.includes(boldPhrase)) {
    writeBoldPhraseLine(ctx, line, boldPhrase);
  } else if (!isLastLine) {
    writeJustifiedLine(ctx, line);
  } else {
    ctx.doc.text(line, ctx.marginLeft, ctx.y);
  }

  ctx.y += 6;
};

const writeMainParagraph = (ctx: PdfCertificadoContext, data: CertificadoData) => {
  ctx.y += 4;
  const boldPhrase = " horas de conducción efectiva";
  const rawText = `Que D/Dña. ${data.nombre} con NIF/NIE ${data.nif} ha realizado en ${data.sede}, ${data.horas} ${boldPhrase}, finalizado satisfactoriamente las prácticas, superando las horas establecidas en la Orden FOM/2872/2010, de 5 de noviembre, para un curso preparatorio de obtención conjunta de licencia de maquinista y el diploma que acredita formación correspondiente a los conocimientos generales mínimos necesarios para los certificados de categoría B. Curso ${data.curso}.`;
  const lines = ctx.doc.splitTextToSize(rawText, ctx.maxTextWidth);

  lines.forEach((line, i) => {
    writeParagraphLine(ctx, line, i === lines.length - 1, boldPhrase);
  });
};

const writeDateLine = (ctx: PdfCertificadoContext, data: CertificadoData) => {
  const fechaActual = formatearFechaActual();
  ctx.y += 18;
  ensureSpace(ctx, 6);
  setCertificateFont(ctx.doc);
  ctx.doc.text(`En ${data.sede}, a ${fechaActual}`, ctx.marginLeft, ctx.y);
};

const calculateSignatureRows = (ctx: PdfCertificadoContext, rowHeight: number, sigTopY: number) => {
  return Math.max(1, Math.floor((ctx.pageHeight - ctx.bottomMargin - sigTopY) / rowHeight));
};

const writeFirma = (
  ctx: PdfCertificadoContext,
  nombre: string,
  xCenter: number,
  yRowTop: number,
  colWidth: number
) => {
  ctx.doc.text("Firmado:", xCenter, yRowTop, { align: "center" });

  const firmaLineWidth = Math.min(45, colWidth - 10);
  const yLine = yRowTop + 12;
  ctx.doc.setDrawColor(0);
  ctx.doc.setLineWidth(0.3);
  ctx.doc.line(xCenter - firmaLineWidth / 2, yLine, xCenter + firmaLineWidth / 2, yLine);

  setCertificateFont(ctx.doc);
  const nombreLines = ctx.doc.splitTextToSize(nombre, colWidth - 10);
  const yNombre = yLine + 6;
  nombreLines.forEach((l, idx) => ctx.doc.text(l, xCenter, yNombre + idx * 5, { align: "center" }));
  setCertificateFont(ctx.doc, "bold");
};

const writeFirmas = (ctx: PdfCertificadoContext, formadoresConTrato: string[]) => {
  const firmantes = formadoresConTrato.length > 0 ? formadoresConTrato : ["D. Formador"];
  const cols = Math.min(3, Math.max(1, firmantes.length));
  const colWidth = (ctx.pageWidth - 2 * ctx.marginLeft) / cols;
  const rowHeight = 35;

  let sigTopY = ctx.y + 20;
  let rowsPerPage = calculateSignatureRows(ctx, rowHeight, sigTopY);
  let slotIndexOnPage = 0;
  const slotsPerRow = cols;

  setCertificateFont(ctx.doc, "bold");

  firmantes.forEach((nombre) => {
    const slotsPerPage = rowsPerPage * slotsPerRow;
    if (slotIndexOnPage >= slotsPerPage) {
      addPageReset(ctx);
      sigTopY = ctx.y;
      rowsPerPage = calculateSignatureRows(ctx, rowHeight, sigTopY);
      slotIndexOnPage = 0;
    }

    const col = slotIndexOnPage % cols;
    const rowOnPage = Math.floor(slotIndexOnPage / cols);
    const xCenter = ctx.marginLeft + col * colWidth + colWidth / 2;
    const yRowTop = sigTopY + rowOnPage * rowHeight;

    writeFirma(ctx, nombre, xCenter, yRowTop, colWidth);
    slotIndexOnPage += 1;
  });
};

const removeOpenAction = (pdf: string): string => {
  const openAction = '/OpenAction [3 0 R /FitH null]';

  return pdf.replace(
    openAction,
    ' '.repeat(openAction.length)
  );
};

const CERTIFICATE_FONT_FAMILY = 'CertificateFont';
const CERTIFICATE_FONT_REGULAR_FILE = 'vialog-lt-regular.ttf';
const CERTIFICATE_FONT_BOLD_FILE = 'alliance-no-1-bold.woff';

// Helper para seleccionar la fuente del certificado
const setCertificateFont = (
  doc: any,
  style: 'normal' | 'bold' = 'normal'
) => {
  doc.setFont(CERTIFICATE_FONT_FAMILY, style);
};

// Convierte una fuente cargada por Webpack a Base64
const getFontBase64 = async (fontUrl: string): Promise<string> => {
  const response = await fetch(fontUrl);

  if (!response.ok) {
    throw new Error(
      `No se ha podido cargar la fuente: ${fontUrl}`
    );
  }

  const buffer = await response.arrayBuffer();

  return abToBase64(buffer);
};

const createPdfContext = async (): Promise<PdfCertificadoContext> => {
  const doc = new jsPDF({
    unit: 'mm',
    format: 'a4',
    putOnlyUsedFonts: true,
  });

  const [regularBase64, boldBase64] = await Promise.all([
    getFontBase64(vialogRegularFontUrl),
    getFontBase64(allianceBoldFontUrl),
  ]);

  // Regular -> Vialog TTF
  doc.addFileToVFS(
    CERTIFICATE_FONT_REGULAR_FILE,
    regularBase64
  );

  doc.addFont(
    CERTIFICATE_FONT_REGULAR_FILE,
    CERTIFICATE_FONT_FAMILY,
    'normal'
  );

  // Bold -> Alliance WOFF
  doc.addFileToVFS(
    CERTIFICATE_FONT_BOLD_FILE,
    boldBase64
  );

  doc.addFont(
    CERTIFICATE_FONT_BOLD_FILE,
    CERTIFICATE_FONT_FAMILY,
    'bold'
  );

  setCertificateFont(doc);

  const marginLeft = 25;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  return {
    doc,
    marginLeft,
    topMarginNext: 30,
    bottomMargin: 25,
    pageWidth,
    pageHeight,
    maxTextWidth: pageWidth - marginLeft * 2,
    centerX: pageWidth / 2,
    y: 0,
  };
};

const savePdfCertificado = async (
  ctx: PdfCertificadoContext,
  data: CertificadoData
) => {
 const nombreArchivo = `${data.nif}_CIPCE_${data.apellidosAlumno},${data.nombreAlumno}.pdf`;

  try {
    const pdfOriginal = ctx.doc.output();

    const pdfSinOpenAction =
      removeOpenAction(pdfOriginal);

    const bytes = new Uint8Array(pdfSinOpenAction.length);

    for (let i = 0; i < pdfSinOpenAction.length; i++) {
      bytes[i] = pdfSinOpenAction.charCodeAt(i);
    }

    const blob = new Blob(
      [bytes],
      { type: 'application/pdf' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    link.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(
      `Error generating PDF for ${data.nombre}:`,
      error
    );
  }
};

const generarPDFCertificado = async (data: CertificadoData) => {
  const ctx = await createPdfContext();
  const logoY = writeHeader(ctx);
  const formadoresConTrato = conTratamiento(data.formadores ?? []);

  writeTitle(ctx, logoY);
  writeFormadoresHeader(ctx, formadoresConTrato);
  writeCertificanBlock(ctx);
  writeMainParagraph(ctx, data);
  writeDateLine(ctx, data);
  writeFirmas(ctx, formadoresConTrato);
  await savePdfCertificado(ctx, data);
};




  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>

        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >

  {/* Bloque izquierdo: Curso + checkbox */}
  <div className="rf-filtro-cursos">
  <div className="single-multiselect-filtro-bloque-izquierdo">

    <RfUiMultiselect
      ref={multiselectCursosRef}
      key={`multiselect-cursos-${multiselectResetKey}`}
      options={JSON.stringify(cursosFiltrados)}
      defaultChecksRemake={selectedCursos}
      withoutOptionsText={language.validations.noOptions}
      textError={language.validations.multiselectEmpty}
      text-label="Curso"
      onOptionSelected={handleSelectedCourse}
      placeholder="Seleccione curso"
      optionsFilter={optionsFilter}
      isFilterActive={isFilterActive}
      multiSelect={false}
    />
  </div>
   <div className="filtro-formadores">

    <RfUiMultiselect
      ref={multiselectFormadoresRef}
      key={`multiselect-formadores-${multiselectResetFormadorKey}`}
      options={JSON.stringify(formadoresFiltrados)}
      defaultChecksRemake={JSON.stringify(
        selectedFormadores.map(id => ({
          value: id,
          label: formadoresFiltrados?.find(f => f.value === id)?.label || id
        }))
      )}
      withoutOptionsText={language.validations.noOptions}
      textError={language.validations.multiselectEmpty}
      text-label="Formadores"
      onOptionSelected={handleSelectedFormador}
      placeholder="Seleccione Formador (mínimo 2 por curso)"
      isFilterActive={isFilterActive}
      disabled={!isFilterActive}
    />
  </div>


  {/* Bloque derecho: Alumno */}
  <div className="filtro-bloque-derecho">
    {['111', '112', '121', '122', '123'].includes(profileActive?.ID_PERFIL) ? (
      <RfUiInput
        label="Alumno"
        value={`${idUsuario} - ${nombreUsuario}`}
        disabled
        error=""
        placeholder="Seleccione alumno"
      />
    ) : (
      <RfUiMultiselect
        key={`multiselect-alumnos-${multiselectResetKey}`}
        withoutOptionsText={language.validations.noOptions}
        options={alumnos}
        defaultChecksRemake={selectedAlumnos}
        textError={language.validations.multiselectEmpty}
        text-label="Alumno"
        onOptionSelected={handleStudentSelected}
        placeholder="Seleccione alumno"
        optionsFilter={optionsFilter}
        isFilterActive={isFilterActive}
        disabled={!isFilterActive}
      />
    )}
  </div>
  </div>
          <div className="rf-box">
            <div
              className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${isMobileOnly
                  ? 'rf-block--mobile rf-text-align-center--mobile'
                  : ''
                }`}
            >
              <RfUiButton
                text="Limpiar filtros"
                text-help="Limpiar filtros"
                aspect="secondary"
                onButtonClick={() => {
                  cleanFilters();
                }}
              >
                {' '}
              </RfUiButton>
              <RfUiButton
                text="Filtrar"
                type="button"
                aspect="primary"
                className="rf-button rf-margin-left-30"
                onButtonClick={() => {
                  handlerSubmitFilters();
                }}
              >
                {' '}
              </RfUiButton>
              {canSee.canSeePerfil ? (
                <RfUiButton
                disabled={!enableGenerarCertificado}
                  text="Generar certificado"
                  type="button"
                  aspect="primary"
                  style={{ marginLeft: "20px", marginRight: "20px" }}
                  onButtonClick={() => {
                    generarPDF();
                  }}
                >
                  {' '}
                </RfUiButton>
              ) : null}

              <RfUiModal
                title-modal={
                  'Seleccione al menos un curso'
                }
                id-modal="modal-validacion-cursos"
                modal-type={modalCerradoType}
                onModalClose={(e: any) => {
                  closeModalCerrado();
                }}
                onConfirm={() => {
                  closeModalCerrado();
                }}
                modalConfirmText="Aceptar"
              ></RfUiModal>
              <RfUiModal
                title-modal={
                  mensajeFormadores
                }
                id-modal="modal-validacion-formadores"
                modal-type={modalCerradoFormadoresType}
                onModalClose={(e: any) => {
                    closeModalCerradoFormadores();
                }}
                onConfirm={() => {
                  closeModalCerradoFormadores();
                }}
                modalConfirmText="Aceptar"
              ></RfUiModal>
               <RfUiModal
                title-modal={
                  mensajeSinFormadores
                }
                id-modal="modal-validacion-formadores-sin-formador"
                modal-type={modalCerradoFormadoresSinFormadoresType}
                onModalClose={(e: any) => {
                    closeModalCerradoFormadoresSinFormadores();
                }}
                onConfirm={() => {
                  closeModalCerradoFormadoresSinFormadores();
                }}
                modalConfirmText="Aceptar"
              ></RfUiModal>
               <RfUiModal
                title-modal={
                  mensajeUnFormador
                }
                id-modal="modal-validacion-formadores-un-formador"
                modal-type={modalCerradoFormadoresUnFormadorType}
                onModalClose={(e: any) => {
                    closeModalCerradoFormadoresUnFormador();
                }}
                onConfirm={() => {
                  closeModalCerradoFormadoresUnFormador();
                }}
                modalConfirmText="Aceptar"
              ></RfUiModal>

            </div>
          </div>
        </form>
      </RfUiAccordionCustom>
    </>
  );
};

export default FilterListPractice;